import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import ProductAddToCartButton from "@insite/content-library/Components/ProductAddToCartButton";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductPrice, { ProductPriceStyles } from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductQuantityOrdered from "@insite/content-library/Components/ProductQuantityOrdered";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import Link from "@insite/mobius/Link";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TextFieldProps } from "@insite/mobius/TextField";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import { unitOfMeasureStyles } from "@tKgpco/Extensions/Widgets/ProductDetails/ProductDetailsUnitOfMeasureSelect";
import { productCarouselProductStyles as productStyle } from "@tKgpco/Overrides/Components/ProductCarouselProduct";
import { COLORS, TYPOGRAPHY } from "@tKgpco/theme/design";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    showPrice: boolean;
    showAddToList: boolean;
}

const mapStateToProps = (state: ApplicationState) => ({
    productSettings: getSettingsCollection(state).productSettings,
});

const mapDispatchToProps = {};

type Props = ReturnType<typeof mapStateToProps> &
    HasProductContext &
    ResolveThunks<typeof mapDispatchToProps> &
    OwnProps;

export interface ProductListActionsStyles {
    wrapper?: InjectableCss;
    addToCartWrapper?: InjectableCss;
    addToCartButton?: ButtonPresentationProps;
    quantityOrdered?: TextFieldProps;
    unitOfMeasureSelect?: SelectPresentationProps;
    quantityBreakPricing?: ProductQuantityBreakPricingStyles;
    price?: ProductPriceStyles;
    addToListLink?: ProductAddToListLinkStyles;
    qtyUmWrapper?: InjectableCss;
    itemNotFound?: InjectableCss;
    notFoundLabel?: TypographyProps;
    salesBlock?: InjectableCss;
}

export const actionsStyles: ProductListActionsStyles = {
    wrapper: {
        css: css`
            display: flex;
            width: 100%;
            flex-direction: column;
            padding: 0 12px;
            margin-top: 0;
            /*position: absolute;
            bottom: 0;*/
        `,
    },
    unitOfMeasureSelect: {
        cssOverrides: {
            formField: css`
                margin-top: 0px;
                flex-direction: row;
                align-items: center;
                background-color: #e1e7ed;
                color: ${COLORS.lightBlack};
                border-radius: 8px;
                margin-bottom: 3px;
                label {
                    text-align: center;
                    padding: 8px;
                    width: 40%;
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 13px !important;
                    }
                }
                & > div {
                    margin-top: 0 !important;
                    select {
                        background: #f1f6fb !important;
                        border-radius: 0px 8px 8px 0px !important;
                        border: none !important;
                    }
                    @media (max-width: 1199px) and (min-width: 992px) {
                        font-size: 13px !important;
                        span[class^="IconWrapper"] {
                            width: 30px !important;
                        }
                    }

                    @media (max-width: 991px) {
                        border-radius: 0 8px 8px 0 !important;
                    }
                }
            `,
        },
    },
    quantityBreakPricing: {
        viewLink: {
            css: css`
                margin: 8px 0;
            `,
        },
    },
    addToCartWrapper: {
        css: css`
            display: flex;
            align-items: flex-end;
            margin-top: 10px;
            flex-grow: 0;
            background: #e1e7ed;
            border-radius: 0;
            label {
                padding-left: 10px;
            }
        `,
    },
    qtyUmWrapper: {
        css: css`
            padding: 12px 12px 8px 12px;
        `,
    },
    addToCartButton: {
        css: css`
            width: 80%;
        `,
    },
    quantityOrdered: {
        cssOverrides: {
            formField: css`
                /*margin-right: 10px;
                width: 4.1rem;
                min-width: 4.1rem;*/
                margin-top: 0px;
                flex-direction: row;
                align-items: center;
                background-color: #e1e7ed;
                color: ${COLORS.lightBlack};
                border-radius: 10px;
            `,
        },
    },
    itemNotFound: {
        css: css`
            font-size: 14px;
            margin: 12px 0px;
            span {
                padding-right: 5px;
            }
        `,
    },
    notFoundLabel: {
        size: 14,
        weight: 700,
    },
    salesBlock: {
        css: css`
            border: 2px solid;
            border-radius: 4px;
            padding: 5px;
            color: #f0b003;
            margin: 10px 0 3px;
            font-weight: bold;
            font-size: 14px;
        `,
    },
};

const styles = actionsStyles;

const ProductListActions: FC<Props> = ({ productContext, productSettings, showPrice, showAddToList }) => {
    const { productInfo } = productContext;
    let showPriceMessage = true;
    if (productInfo?.pricing?.additionalResults?.showContactUsMessage?.toLowerCase() === "true") {
        showPriceMessage = false;
    }
    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                {showPrice && (
                    <>
                        {showPriceMessage ? (
                            <StyledWrapper>
                                <Typography {...styles.notFoundLabel}>{translate("Your Price:")}</Typography>
                            </StyledWrapper>
                        ) : (
                            <StyledWrapper>
                                <Typography {...styles.notFoundLabel}>{translate("List Price:")}</Typography>
                            </StyledWrapper>
                        )}
                        <StyledWrapper {...productStyle.productPriceWrapper}>
                            <ProductPrice
                                product={productContext}
                                showLabel={false}
                                showSavings={true}
                                showSavingsAmount={productSettings.showSavingsAmount}
                                showSavingsPercent={productSettings.showSavingsPercent}
                                extendedStyles={styles.price}
                            />
                            <ProductQuantityBreakPricing extendedStyles={styles.quantityBreakPricing} />
                        </StyledWrapper>
                    </>
                )}
                {!showPriceMessage ? (
                    <StyledWrapper {...styles.itemNotFound}>
                        <Link href="/contact-kgpco">{translate("Contact Us")}</Link>
                        <Typography>{translate("for pricing & availability for this item.")}</Typography>
                    </StyledWrapper>
                ) : null}
            </StyledWrapper>

            <StyledWrapper {...styles.qtyUmWrapper}>
                <ProductUnitOfMeasureSelect extendedStyles={styles.unitOfMeasureSelect} />
                {showPriceMessage && (
                    <ProductQuantityOrdered extendedStyles={productStyle.productQuantityOrderedStyles} />
                )}
            </StyledWrapper>

            {productContext.product.properties?.salesBlocked?.toLowerCase() === "true" ? (
                <StyledWrapper {...styles.salesBlock}>{siteMessage("sales_block_product_msg")}</StyledWrapper>
            ) : null}

            {productContext.productInfo && productContext.productInfo.pricing && (
                <ProductAddToCartButton
                    data-test-selector={`actionsAddToCart${productContext.product.id}`}
                    extendedStyles={productStyle.productAddToCartButtonStyles}
                />
            )}
            {showAddToList && showPriceMessage && (
                <StyledWrapper>
                    <ProductAddToListLink
                        data-test-selector={`actionsAddToList${productContext.product.id}`}
                        extendedStyles={productStyle.productAddToListLinkStyles}
                    />
                </StyledWrapper>
            )}
        </>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(withProductContext(ProductListActions));
